import Honeybadger from 'honeybadger-js';

const config = {
  apiKey: process.env.HONEYBADGER_JS_API_KEY,
  environment: process.env.AVOCHATO_ENV ?? 'dev',
  developmentEnvironments: ['dev'],
  revision: process.env.GIT_COMMIT,
  projectRoot: 'webpack:///./',
};

declare global {
  interface Error {
    reported?: boolean;
    responseJSON?: any;
  }
}

const { notify } = Honeybadger;
Honeybadger.notify = function notifyWrapper(...args: Parameters<typeof Honeybadger['notify']>) {
  const [err] = args;
  if (err instanceof Error) {
    if (err.reported) return undefined;
    if (err.message && err.message.includes('ResizeObserver loop limit exceeded')) return undefined;
    err.reported = true; // eslint-disable-line no-param-reassign
  }
  return notify.apply(this, args);
};

export { Honeybadger };
export const honeybadger = Honeybadger.configure(config);
